<sb-searchable-list-section
	[emptyListContent]="emptyListContent()"
	[emptyListTitle]="emptyListTitle()"
	[hideFilter]="hideFilter()"
	[persuadeCards]="packageEventItems()"
	[title]="title()"
	[useStoryblokCards]="false"
/>
